import type { SVGProps } from 'react';
const SiTrendingUpFill = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="1em" height="1em" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.76038 9.37508L8.11454 4.79175"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.55204 16.042H4.94788C5.3851 16.042 5.73955 15.6689 5.73955 15.2086V13.1251C5.73955 12.6648 5.3851 12.2917 4.94788 12.2917H4.55204C4.11482 12.2917 3.76038 12.6648 3.76038 13.1251V15.2086C3.76038 15.6689 4.11482 16.042 4.55204 16.042Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.30204 16.042H9.69788C10.1351 16.042 10.4895 15.6689 10.4895 15.2086V10.6251C10.4895 10.1648 10.1351 9.79175 9.69788 9.79175H9.30204C8.86482 9.79175 8.51038 10.1648 8.51038 10.6251V15.2086C8.51038 15.6689 8.86482 16.042 9.30204 16.042Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.052 16.0418H14.4479C14.8851 16.0418 15.2395 15.6687 15.2395 15.2085V4.79159C15.2395 4.33135 14.8851 3.95825 14.4479 3.95825H14.052C13.6148 3.95825 13.2604 4.33135 13.2604 4.79159V15.2085C13.2604 15.6687 13.6148 16.0418 14.052 16.0418Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.90621 6.87492V3.95825H6.13538"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SiTrendingUpFill;
